import { DateTime } from "luxon";
import { z } from "zod";
import { Branded } from "./types";

export const Base64Z = z.string();
export type Base64 = string;
export const Base58Z = z.string();
export type Base58 = string;
export const HexZ = z.string();
export type Hex = string;

export type HexColor = Branded<"HexColor">; // #bb2dc7

export type IpAddress = Branded<"IpAddress">;

export type Latitude = Branded<"Latitude">;
export type Longitude = Branded<"Longitude">;

// This represents a translated string
export type TString = Branded<"TString">;
export const TStringZ: z.Schema<TString> = z.string() as any;

export type EthHex = `0x${string}`;

export const IsoDateZ = z.string().refine((str) => {
  try {
    const dt = DateTime.fromISO(str);
    return dt.isValid;
  } catch {
    return false;
  }
});
export type IsoDate = string; // 2022-10-19T03:27:13.673Z

/**
 * ISO 8601
 * example: P0Y0M0DT0H10M0S
 */
export type IsoDuration = Branded<"IsoDuration">;
export const IsoDurationZ: z.Schema<IsoDuration> = z.string() as any;
